export function nullToUndefined<T>(value: T) {
	if (value === null) {
		return undefined;
	}
	return value as Exclude<T, null>;
}
